<template>
  <div id="app">
    <div class="h-screen flex overflow-hidden bg-gray-100">
      <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->
      <button class="flex md:hidden items-center justify-center h-12 w-12 rounded-full focus:outline-none bg-white absolute top-32 left-32" @click="showMobileMenu = !showMobileMenu">
      <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="z-10 text-khks-red h-8 w-8 ">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" />
      </svg>
      </button>
      <div class="md:hidden">
        <div v-show="this.showMobileMenu" class="fixed inset-0 flex z-40 ">
          <div class="fixed inset-0">
            <div class="absolute inset-0 bg-gray-600 opacity-75"></div>
          </div>
          <div class="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-khks-red">
            <div class="absolute top-0 right-0 -mr-14 p-1">
              <button class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600" @click="showMobileMenu = !showMobileMenu">
                <svg class="h-6 w-6 text-gray-300" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div class="flex-shrink-0 flex items-center px-4">
              <img class="h-8 w-auto" src="@/assets/img/logo.jpg" alt="Workflow">
            </div>
            <div class="mt-5 flex-1 h-0 overflow-y-auto">
              <nav class="px-2 space-y-1">
                <a @click="showModalMethod(); hideInfoAlert(); showMobileMenu = !showMobileMenu;" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md  hover:text-gray-300 hover:bg-khks-red-hover focus:bg-khks-red focus:text-gray-300 focus:outline-none transition ease-in-out duration-150">
                  <!-- Heroicon name: home -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                 </svg>
                  Etsi palvelua
                </a>
                <a v-on:click="showPaivystys();" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md hover:text-gray-300 hover:bg-khks-red-hover focus:bg-khks-red focus:outline-none focus:text-gray-300 transition ease-in-out duration-150">
                  <!-- Heroicon name: users -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                  Päivystys
                </a>
                <div class="py-2" />
                <a v-on:click="showMobileMenu = !showMobileMenu; parkkipaikat = !parkkipaikat;" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md  hover:text-gray-300 hover:bg-khks-red-hover focus:bg-khks-red focus:text-gray-300 focus:outline-none transition ease-in-out duration-150">
                  <!-- Heroicon name: users -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Parkkipaikat
                </a>
                <a v-on:click="showMobileMenu = !showMobileMenu; taksi = !taksi;" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md hover:text-gray-300 hover:bg-khks-red-hover focus:bg-khks-red focus:outline-none focus:text-gray-300 transition ease-in-out duration-150">
                  <!-- Heroicon name: users -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Taksitolppa
                </a>
                <a v-on:click="showMobileMenu = !showMobileMenu; bussi = !bussi;" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md hover:text-gray-300 hover:bg-khks-red-hover focus:outline-none focus:text-gray-300 transition ease-in-out duration-150">
                  <!-- Heroicon name: users -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Bussipysäkki
                </a>
              </nav>
            </div>
          </div>
          <div class="flex-shrink-0 w-14">
            <!-- Dummy element to force sidebar to shrink to fit close icon -->
          </div>
        </div>
      </div>

      <!-- Static sidebar for desktop -->
      <div class="hidden md:flex md:flex-shrink-0">
        <div class="flex flex-col w-64">
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <div class="flex flex-col flex-grow border-r border-gray-200 pt-5 pb-4 bg-khks-red overflow-y-auto">
            <div class="flex items-center flex-shrink-0 px-4">
              <img class="h-8 w-auto" src="@/assets/img/logo.jpg" alt="Workflow">
            </div>
            <div class="mt-5 flex-grow flex flex-col">
              <nav class="flex-1 px-3 space-y-1">
                <a @click="showModalMethod(); hideInfoAlert();" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md  hover:text-gray-300 hover:bg-khks-red-hover focus:bg-khks-red focus:text-gray-300 focus:outline-none transition ease-in-out duration-150">
                  <!-- Heroicon name: home -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-600 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                 </svg>
                  Etsi palvelua
                </a>
                <a v-on:click="showPaivystys();" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md hover:text-gray-300 hover:bg-khks-red-hover focus:bg-khks-red focus:outline-none focus:text-gray-300 transition ease-in-out duration-150">
                  <!-- Heroicon name: users -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                  </svg>
                  Päivystys
                </a>
                <div class="py-2" />
                <a v-on:click="parkkipaikat = !parkkipaikat" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md  hover:text-gray-300 hover:bg-khks-red-hover focus:bg-khks-red focus:text-gray-300 focus:outline-none transition ease-in-out duration-150">
                  <!-- Heroicon name: users -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Parkkipaikat
                </a>
                <a v-on:click="taksi = !taksi" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md hover:text-gray-300 hover:bg-khks-red-hover focus:bg-khks-red focus:outline-none focus:text-gray-300 transition ease-in-out duration-150">
                  <!-- Heroicon name: users -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Taksitolppa
                </a>
                <a v-on:click="bussi = !bussi" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-bold text-gray-300 rounded-md hover:text-gray-300 hover:bg-khks-red-hover focus:outline-none focus:text-gray-300 transition ease-in-out duration-150">
                  <!-- Heroicon name: users -->
                  <svg class="mr-3 h-6 w-6 text-gray-300 group-hover:text-gray-500 group-focus:text-gray-500 transition ease-in-out duration-150" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  Bussipysäkki
                </a>
              </nav>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col w-0 flex-1 overflow-hidden">
        <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
          <PaivystysAlert :paivystys="this.paivystys" v-if="this.paivystys"/>
          <InfoAlert :service="this.selectedService"  v-if="this.showInfo" />
          <ServicesModal v-if="showModal" @close="showModal = false" v-bind:services="this.services" v-bind:building="this.building" v-on:selectedServiceMethod="onServiceClick" v-on:closeModal="closeModalRefresh"/>

          <div>
            <div class=" mx-auto">
              <Map v-bind:services="this.services" :door="this.door" v-bind:bussi="this.bussi" v-bind:taksi="this.taksi" v-bind:parkkipaikat="this.parkkipaikat" v-on:selectedBuildingMethod="onBuildingClick"/>
            </div>
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";
import Map from "./components/Map.vue";
import ServicesModal from "./components/ServicesModal.vue";
import BuildingServicesModal from "./components/buildingServicesModal.vue";
import PaivystysAlert from "./components/paivystysAlert.vue";
import InfoAlert from "./components/InfoAlert.vue";
import axios from 'axios';

export default {
  name: "App",
  components: {
    HelloWorld,
    Map,
    ServicesModal,
    BuildingServicesModal,
    PaivystysAlert,
    InfoAlert
  },
  data () {
    return {
      services: null,
      showModal: false,
      showBuildingModal: false,
      showInfo: false,
      parkkipaikat: false,
      bussi: false,
      taksi: false,
      paivystys: false,
      selectedService: null,
      door: null,
      building: null,
      showMobileMenu: false,
    }
  },
  methods: {
    onServiceClick (service) {
      this.showInfo = true;
      this.selectedService = service;
      this.door = service.door._text;
      this.building = null;
    },
    onBuildingClick (building) {
      this.showModal = true;
      this.building = building;
      console.log(building);
    },
    closeModalRefresh (building) {
      this.building = null;
    },
    hideInfoAlert (){
      this.showInfo = false;
      this.door = null;
      this.paivystys = false;
    },
    showModalMethod () {
      this.showModal = true;
    },
    showPaivystys () {
      this.showInfo = false;
      this.showMobileMenu = !this.showMobileMenu;
      this.paivystys = !this.paivystys
      if (this.paivystys) {
        this.door = "E5";
      }
      else {
        this.door = '';
      }
    },
    mobilebussi () {
      bussi = !bussi; 
      this.showMobileMenu = false;
    }
  },
  mounted () {
    axios
      .get('https://cnow.fi/khks/tilat/data.xml',{ crossdomain: true })
      .then(response => {
        var convert = require('xml-js');
        var xml = response.data;
        var options = {compact: true, ignoreComment: false, alwaysChildren: true};
        var result = convert.xml2js(xml, options); // or convert.xml2json(xml, options)
        this.services = result.data;
      });        
  }
      
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
